import React from 'react';
import { connect } from 'react-redux';
import { CollectionsBucket } from '../../../../components/FeaturedCollections';
import { ConnectedProps, DiscoverState } from '../../../../types/index';
import {
    clickOnOnlineCollection,
    clickOnTransitionOnlineCollection,
} from '../../redux/content';

const CollectionsBucketContainer = (props: CollectionsBucketContainerProps) => {
    const { trackGAEvent, trackGAEventOnPageUnload, tld, placeId } = props;

    return (
        <CollectionsBucket
            tld={tld}
            currentPlace={placeId || 'online'}
            trackGAEvent={trackGAEvent}
            trackGAEventOnPageUnload={trackGAEventOnPageUnload}
        />
    );
};

const _mapStateToProps = ({ app, location }: DiscoverState) => ({
    isFeLoading: app.loadingState && app.loadingState.isFeLoading,
    isBotRequest: app.isBotRequest,
    placeId: location.placeId,
    tld: app.tld,
});

const _mapDispatchToProps = {
    trackGAEventOnPageUnload: clickOnOnlineCollection,
    trackGAEvent: clickOnTransitionOnlineCollection,
};

type CollectionsBucketContainerProps = ConnectedProps<
    typeof _mapStateToProps,
    typeof _mapDispatchToProps
>;
export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(CollectionsBucketContainer);
